import React, { useEffect } from 'react';
import thermogreen from '../../assets/thermogreen.png';
import plug from '../../assets/plug-img.jpg';
import { ReactComponent as DeviceRotation } from '../../assets/devicerotation.svg';

import './style.scss';

const PlugRotation = () => {
  useEffect(() => {
    setTimeout(() => {
      document.querySelector('.loader').classList.add('hidden');

      setTimeout(() => {
        document.querySelector('.loader').classList.add('hidden2');
      }, 1000);
    }, 2000);
  }, []);

  return (
    <div className="wrapper-plug-rotation">
      <div className="content-plug">
        <div className="container-img-plug">
          <img className="content-logo-plug" src={thermogreen} alt="" />
          <img className="content-bg-plug" src={plug} alt="" />
          <div className="content-title-plug"> Thermogreen 3D Experience</div>
        </div>

        <div className="container-description-plug">
          <div className="content-description-plug">
            Erleben Sie eine faszinierende Welt der Möglichkeiten und entdecken
            Sie unendliche Kreativität – doch dafür benötigen Sie etwas mehr
            vertikalen Platz. <br /> <br /> Bitte drehen Sie Ihr mobiles Gerät
            um 90 Grad, um fortzufahren. Vielen Dank.
          </div>
        </div>

        <div className="container-devices-plug">
          <div className="content-devices-plug center">
            <DeviceRotation />
          </div>
        </div>

        <div className="container-info-plug"> </div>
      </div>
    </div>
  );
};

export default PlugRotation;
